import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { customApi } from '../pocketbase';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import './RedirectPage.css';

export default function RedirectPage() {
    const { slug } = useParams();
    const location = useLocation();
    const [error, setError] = useState(null);
    const [debugInfo, setDebugInfo] = useState([]);

    const addLog = (message, data = null) => {
        const timestamp = new Date().toISOString();
        const logEntry = `[${timestamp}] ${message}`;
        console.log(logEntry, data || '');
        setDebugInfo(prev => [...prev, { message, data, timestamp }]);
    };

    // Используем sessionStorage для предотвращения повторных вызовов
    // (работает даже при перемонтировании компонента в StrictMode)
    const getProcessedKey = (s) => `redirect_processed_${s}`;

    useEffect(() => {
        const handleRedirect = async () => {
            // Prevent double-processing of the same slug using sessionStorage
            const processedKey = getProcessedKey(slug);
            if (sessionStorage.getItem(processedKey)) {
                addLog('⚠️ Slug already processed (sessionStorage), skipping', slug);
                return;
            }
            // Mark as processed immediately
            sessionStorage.setItem(processedKey, Date.now().toString());

            try {
                addLog('🚀 RedirectPage mounted');
                addLog('📍 Current URL', window.location.href);
                addLog('📍 Location pathname', location.pathname);
                addLog('🔑 Slug from useParams', slug);

                if (!slug) {
                    addLog('❌ No slug found!');
                    setError('Slug не найден в URL');
                    return;
                }

                addLog('📞 Calling PocketBase: resolve-redirect', { slug });

                // Вызываем custom API для получения target_url и инкремента счетчика
                let data;
                try {
                    data = await customApi('GET', `/api/custom/resolve-redirect/${slug}`);
                } catch (rpcError) {
                    addLog('❌ API Error', rpcError);
                    console.error('API error:', rpcError);
                    addLog('🏠 Redirect not found, redirecting to home');
                    window.location.href = '/';
                    return;
                }

                addLog('✅ API Success, processing data', data);

                const redirectData = data;

                addLog('📊 Redirect data extracted', redirectData);

                if (!redirectData || !redirectData.target_url) {
                    addLog('❌ No target_url in response, redirecting to home');
                    window.location.href = '/';
                    return;
                }

                addLog('🎯 Target URL found', redirectData.target_url);
                addLog('📈 Click count', redirectData.click_count);
                addLog('🏷️ Campaign', redirectData.campaign_name);

                // Переадресация на целевой URL
                addLog('🔄 Redirecting now...', redirectData.target_url);
                console.log(`%c🚀 REDIRECTING TO: ${redirectData.target_url}`, 'color: green; font-size: 16px; font-weight: bold;');

                window.location.href = redirectData.target_url;

            } catch (err) {
                addLog('💥 Unexpected error caught', err);
                console.error('Unexpected error:', err);
                setError(`Произошла непредвиденная ошибка: ${err.message}`);
            }
        };

        if (slug) {
            handleRedirect();
        } else {
            addLog('⚠️ useEffect triggered but no slug');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug]); // Removed location.pathname from dependencies to avoid unnecessary re-runs

    if (error) {
        return (
            <div className="redirect-page">
                <div className="redirect-error">
                    <div className="error-icon">⚠️</div>
                    <h2>Ошибка</h2>
                    <p>{error}</p>
                    <details style={{ marginTop: '20px', textAlign: 'left', maxWidth: '100%' }}>
                        <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                            🔍 Debug Info (нажмите чтобы раскрыть)
                        </summary>
                        <div style={{
                            marginTop: '10px',
                            padding: '10px',
                            background: '#f5f5f5',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontFamily: 'monospace',
                            maxHeight: '300px',
                            overflow: 'auto'
                        }}>
                            {debugInfo.map((log, idx) => (
                                <div key={idx} style={{ marginBottom: '8px', borderBottom: '1px solid #ddd', paddingBottom: '4px' }}>
                                    <strong>{log.message}</strong>
                                    {log.data && (
                                        <pre style={{ margin: '4px 0', fontSize: '11px' }}>
                                            {JSON.stringify(log.data, null, 2)}
                                        </pre>
                                    )}
                                </div>
                            ))}
                        </div>
                    </details>
                    <button
                        className="btn-home"
                        onClick={() => window.location.href = '/home'}
                        style={{ marginTop: '20px' }}
                    >
                        Перейти на главную
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="redirect-page">
            <LoadingSpinner />
            <p className="redirect-message">Переадресация...</p>
            <details style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
                <summary style={{ cursor: 'pointer' }}>Debug Info</summary>
                <div style={{
                    marginTop: '10px',
                    padding: '10px',
                    background: '#f5f5f5',
                    borderRadius: '8px',
                    textAlign: 'left',
                    fontFamily: 'monospace',
                    fontSize: '11px',
                    maxHeight: '200px',
                    overflow: 'auto'
                }}>
                    {debugInfo.map((log, idx) => (
                        <div key={idx} style={{ marginBottom: '4px' }}>
                            {log.message}
                        </div>
                    ))}
                </div>
            </details>
        </div>
    );
}
